import React from 'react'
import { DatePicker } from 'antd'
import { formatValue } from 'utils'
const { RangePicker } = DatePicker
export interface AppDatePickerProps {
	field?: string
	value?: string | number
	format?: string
	dataType?: 'string' | 'number'
	onChange?: (value: any, text: string) => void
	width?: number | string
	label?: string
	itemWidth?: number
	colSpan?: number
	labelHidden?: boolean
	placeholder?: string
	req?: boolean
	disabled?: boolean
}

export default class AppDatePicker extends React.Component<AppDatePickerProps> {
	state = { value: this.props.value, text: formatValue(this.props.value, this.props.format) }

	change = (date: any, dateString: any) => {
		let text = dateString
		this.setState({ text })
	}

	render() {
		let { text, value } = this.state
		return (
			<RangePicker
				style={{ width: this.props.width }}
				onChange={this.change}
				data-field={this.props.field || ''}
				data-value={this.state.value}
				data-type={this.props.dataType || 'string'}
				className="app-input"
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppDatePicker.tsx